import { useTheme } from '@mui/material/styles'

export const ErrorMessage = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme()
  return (
    <div
      role="alert"
      style={{
        marginTop: 4,
        marginBottom: 0,
        marginRight: 14,
        marginLeft: 14,
        fontSize: '0.75rem',
        color: theme.palette.error.main
      }}
    >
      {children}
    </div>
  )
}
